import DOMPurify from 'dompurify';

const INLINE_STYLE_PROPS_TO_STRIP = [
  'background',
  'background-color',
  'color',
];

export function isHtmlContent(text) {
  return /<[a-z][\s\S]*>/i.test(String(text || '').trim());
}

export function normalizeDescriptionHtml(html) {
  if (!html || typeof html !== 'string') return html;

  let output = html
    .replace(/\s*background(-color)?\s*:\s*[^;"]+;?/gi, '')
    .replace(/\s*color\s*:\s*[^;"]+;?/gi, '');

  if (typeof document === 'undefined') {
    return output;
  }

  const div = document.createElement('div');
  div.innerHTML = output;

  div.querySelectorAll('[style]').forEach((el) => {
    INLINE_STYLE_PROPS_TO_STRIP.forEach((prop) => {
      el.style.removeProperty(prop);
    });
    if (!el.getAttribute('style')?.trim()) {
      el.removeAttribute('style');
    }
  });

  div.querySelectorAll('font[color]').forEach((el) => {
    el.removeAttribute('color');
  });

  return div.innerHTML;
}

export function sanitizeRichHtml(html) {
  const sanitized = DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_ATTR: ['target', 'rel', 'style', 'class'],
  });
  return normalizeDescriptionHtml(sanitized);
}

export function isRichTextEmpty(html) {
  const stripped = String(html || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
  return !stripped;
}
